import api from './api';

// Shared read-only overview for ADMIN + MEMBER.
export const getCertificationOverview = async () => {
  const res = await api.get('/certifications/overview');
  return res.data;
};

// ADMIN ONLY — full roster across every user
export const getAllCertifications = async () => {
  const res = await api.get('/certifications');
  return res.data; // certs[] with user + certificationType + partner nested
};

// MEMBER's own records (ADMIN can also call this for themselves)
export const getMyCertifications = async () => {
  const res = await api.get('/certifications/my');
  return res.data;
};

// Create — server forces userId to the requester unless caller is ADMIN
export const createCertification = async (payload) => {
  const res = await api.post('/certifications', payload);
  return res.data;
};

// Update — owner or ADMIN only (server-enforced)
export const updateCertification = async (id, payload) => {
  const res = await api.patch(`/certifications/${id}`, payload);
  return res.data;
};

// Delete — owner or ADMIN only (server-enforced)
export const deleteCertification = async (id) => {
  const res = await api.delete(`/certifications/${id}`);
  return res.data;
};